import { render, staticRenderFns } from "./PersonalWeb.vue?vue&type=template&id=861abeae"
import script from "./PersonalWeb.vue?vue&type=script&lang=js"
export * from "./PersonalWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports